import styled from 'styled-components';
import { spacingWithBorder } from '../../../helpers/spacing';
import {
  borderPx,
  coloredBorder,
  defaultBorder,
  insetShadowOrSolidBackground,
  outsetShadow,
  panelContainer,
} from '../styles';
import { BasePanelProps } from '../types';

export const SimplePanelContainer = styled.div<BasePanelProps>`
  ${panelContainer}
  ${insetShadowOrSolidBackground}
  ${({ borderShadows }) => borderShadows?.displayOutset && outsetShadow}
  ${({ colors, borderShadows }) =>
    borderShadows?.displayOutset || colors?.primaryColor ? coloredBorder : defaultBorder}

  padding: ${spacingWithBorder(2, borderPx)};
`;
